import PropTypes from 'prop-types';
import { ArticleCard, Grid, GridItem } from '@bwoty-web/ui-kit';

import './packagePlusOtherOptions.scss';

const PackagePlusOtherOptions = ({ headerText, otherOptions }) => {
  return (
    <>
      {headerText && <h2 className="iw-combo-summary__section-heading">{headerText}</h2>}
      <Grid>
        {otherOptions.map((o) => (
          <GridItem
            key={`${o.extraId}_${o.name}`}
            columnSpan={12}
          >
            <ArticleCard
              className="iw-combo-summary__other-options-card"
              columnSpan={12}
              imageWidth={4}
              imagePosition="left"
              image={o.mainImage}
              title={`${o.name}`}
              description={
                <span style={{ whiteSpace: 'nowrap' }}>
                  {' '}
                  {` ${o.presentationDate}
                ${o.presentationDate !== o.presentationToDate ? ` - ${o.presentationToDate}` : ''}`}
                </span>
              }
            />
          </GridItem>
        ))}
      </Grid>
    </>
  );
};

PackagePlusOtherOptions.propTypes = {
  headerText: PropTypes.string.isRequired,
  otherOptions: PropTypes.arrayOf(
    PropTypes.shape({
      extraId: PropTypes.string,
      mainImage: PropTypes.PropTypes.shape({}),
      name: PropTypes.string,
      presentationDate: PropTypes.string,
      presentationToDate: PropTypes.string,
    }),
  ).isRequired,
};

export default PackagePlusOtherOptions;
